import { jsxs as i, jsx as e } from "react/jsx-runtime";
const r = () => /* @__PURE__ */ i(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "181",
    height: "132",
    viewBox: "0 0 181 132",
    fill: "none",
    children: [
      /* @__PURE__ */ e(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M73.1162 108.919C46.3995 108.919 24.7413 87.2609 24.7413 60.5441C24.7413 33.8274 46.3995 12.1692 73.1162 12.1692C99.156 12.1692 120.39 32.7438 121.45 58.5235C122.767 58.3514 124.111 58.2626 125.476 58.2626C142.477 58.2626 156.26 72.0451 156.26 89.0466C156.26 106.048 142.477 119.831 125.476 119.831C113.196 119.831 102.596 112.641 97.6552 102.242C90.461 106.485 82.0729 108.919 73.1162 108.919Z",
          fill: "#DEE6FD"
        }
      ),
      /* @__PURE__ */ i("g", { clipPath: "url(#clip0_5763_13807)", children: [
        /* @__PURE__ */ e(
          "path",
          {
            d: "M87.5 93.3567H70.1562",
            stroke: "black",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M101.375 87.4817H49.3438C47.5038 87.4817 45.7392 86.7508 44.4382 85.4497C43.1372 84.1487 42.4062 82.3841 42.4062 80.5442V38.9192C42.4062 37.0792 43.1372 35.3147 44.4382 34.0136C45.7392 32.7126 47.5038 31.9817 49.3438 31.9817H111.781C113.621 31.9817 115.386 32.7126 116.687 34.0136C117.988 35.3147 118.719 37.0792 118.719 38.9192V45.8567",
            fill: "white"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M101.375 87.4817H49.3438C47.5038 87.4817 45.7392 86.7508 44.4382 85.4497C43.1372 84.1487 42.4062 82.3841 42.4062 80.5442V38.9192C42.4062 37.0792 43.1372 35.3147 44.4382 34.0136C45.7392 32.7126 47.5038 31.9817 49.3438 31.9817H111.781C113.621 31.9817 115.386 32.7126 116.687 34.0136C117.988 35.3147 118.719 37.0792 118.719 38.9192V45.8567",
            stroke: "black",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M136.062 94.4192V52.7942C136.062 48.9627 132.956 45.8567 129.125 45.8567H108.312C104.481 45.8567 101.375 48.9627 101.375 52.7942V94.4192C101.375 98.2507 104.481 101.357 108.312 101.357H129.125C132.956 101.357 136.062 98.2507 136.062 94.4192Z",
            fill: "white",
            stroke: "black",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ e(
          "path",
          {
            d: "M115.25 59.7317H122.188",
            stroke: "black",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        )
      ] }),
      /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ e("clipPath", { id: "clip0_5763_13807", children: /* @__PURE__ */ e("rect", { width: "111", height: "111", fill: "white", transform: "translate(32 11.1692)" }) }) })
    ]
  }
);
export {
  r as DevicesIllustration
};
//# sourceMappingURL=index.es485.js.map
